class ArchiveGallery extends HTMLElement {
  constructor() {
    super();
    this.activeVideos = [];

    this.fauxPrev = this.querySelector("[data-prev]");
    this.fauxNext = this.querySelector("[data-next]");

    window.loadSwiper.then(({ Swiper, Virtual }) => {
      this.Swiper = Swiper;
      this.Virtual = Virtual;

      this._initCarousel();
    });
  }

  _initCarousel() {
    const slidesScript = this.querySelector("[data-virtual-slides]");
    const slides = slidesScript ? JSON.parse(slidesScript.textContent) : [];

    const updateCurrentSlide = () => {
      if (!this.gallerySwiper) return;

      this.gallerySwiper.slides.forEach((slide) => {
        const isActive = slide.classList.contains("swiper-slide-active");
        if (isActive) {
          slide.removeAttribute("aria-hidden");
          slide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = null;
          });
        } else {
          slide.setAttribute("aria-hidden", "true");
          slide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = -1;
          });
        }
      });
    };

    const swiperParams = {
      modules: [this.Virtual],
      slidesPerView: 1,
      initialSlide: parseInt(this.dataset.preselectMediaIndex, 10) || 0,
      speed: 400,
      watchSlidesProgress: true,
      keyboard: {
        enabled: true,
      },
      loop: false,
      spaceBetween: 20,
      virtual: {
        slides,
        renderSlide: (slide) => slide,
      },
      init: false,
      on: {
        slideChange: () => updateCurrentSlide(),
      },
    };

    this.gallerySwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    updateCurrentSlide();

    const processVisibleSlides = () => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    };

    this.gallerySwiper.on("afterInit", processVisibleSlides);
    this.gallerySwiper.on("slideChange", processVisibleSlides);

    this.fauxPrev.addEventListener("click", () => {
      this.gallerySwiper.slidePrev();
    });

    this.fauxNext.addEventListener("click", () => {
      this.gallerySwiper.slideNext();
    });

    this.gallerySwiper.init();
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }
}

if (!customElements.get("archive-gallery")) {
  customElements.define("archive-gallery", ArchiveGallery);
}
